import { Field, SectionCard, StatRow, StatTile } from '@/components/ui/section-card';
import type { SectionTone } from '@/components/ui/section-card';
import { ENROLLMENT_STATUS } from '@/types/enrollment-status';
import { Enrollments } from '@/types/enrollments';
import { formatCurrency } from '@/utils/format-currency';
import { formatDate } from '@/utils/format-date';
import React from 'react';
import { View } from 'react-native';

type EnrollmentDetailsTabProps = {
  enrollment: Enrollments | null;
  initialServiceName?: string;
};

const STATUS_META: Record<ENROLLMENT_STATUS, { label: string; tone: SectionTone }> = {
  [ENROLLMENT_STATUS.ACTIVE]: { label: 'Ativo', tone: 'success' },
  [ENROLLMENT_STATUS.PAUSED]: { label: 'Pausado', tone: 'warning' },
  [ENROLLMENT_STATUS.INACTIVE]: { label: 'Pausado', tone: 'warning' },
  [ENROLLMENT_STATUS.PENDING_APPROVAL]: { label: 'Aguardando aprovação', tone: 'warning' },
  [ENROLLMENT_STATUS.COMPLETED]: { label: 'Concluído', tone: 'muted' },
  [ENROLLMENT_STATUS.CANCELLED]: { label: 'Cancelado', tone: 'danger' },
};

/**
 * Aba de leitura do contrato: quem é o cliente, qual serviço, valor, vigência e
 * status. Sem campos de formulário — editar vive no `ContractFormScreen`.
 */
export function EnrollmentDetailsTab({ enrollment, initialServiceName }: EnrollmentDetailsTabProps) {
  if (!enrollment) return null;

  const client = enrollment.client;
  const statusMeta = STATUS_META[enrollment.status] ?? { label: enrollment.status, tone: 'neutral' };
  const phone = client?.phone || client?.user?.phone;

  return (
    <View className="w-full gap-5 px-5 pt-5">
      <SectionCard icon="person-outline" title="Cliente">
        <Field label="Nome" value={client?.user?.username} />
        {client?.user?.email ? <Field label="E-mail" value={client.user.email} /> : null}
        {phone ? <Field label="Telefone" value={phone} /> : null}
      </SectionCard>

      <SectionCard
        icon="document-text-outline"
        title="Contrato"
        badge={statusMeta.label}
        badgeTone={statusMeta.tone}
      >
        <Field label="Serviço" value={enrollment.service?.name ?? initialServiceName} />
        <StatRow>
          <StatTile label="Valor" value={formatCurrency(enrollment.price)} emphasis />
          <StatTile
            label="Início"
            value={enrollment.startDate ? formatDate(enrollment.startDate) : '—'}
          />
        </StatRow>
        <Field
          label="Término"
          value={enrollment.endDate ? formatDate(enrollment.endDate) : undefined}
          emptyText="Sem data de término"
        />
        {enrollment.createdAt ? (
          <Field label="Criado em" value={formatDate(enrollment.createdAt)} />
        ) : null}
      </SectionCard>
    </View>
  );
}
